<template>
  <div class="td-backdrop" @mousedown.self="$emit('close')">
    <div class="td-modal">
      <div class="td-icon-wrap">
        <svg width="22" height="22" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
        </svg>
      </div>

      <h2 class="td-title">Delete template</h2>
      <p class="td-desc">
        Are you sure you want to delete the template named <strong>„{{ template && template.name }}"</strong>?
        This action cannot be undone.
      </p>

      <div class="td-actions">
        <button class="td-btn-ghost" :disabled="loading" @click="$emit('close')">
          Cancel
        </button>
        <button class="td-btn-danger" :disabled="loading" @click="$emit('confirm')">
          <span v-if="loading" class="td-spinner"></span>
          Delete
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplateDeleteDialog',

  props: {
    template: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.td-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.td-modal {
  background: #fff;
  border-radius: 14px;
  width: 100%;
  max-width: 400px;
  padding: 28px 28px 24px;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.2);
  text-align: center;
}

.td-icon-wrap {
  width: 52px;
  height: 52px;
  background: #fef2f2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  color: #dc2626;
}

.td-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px;
}

.td-desc {
  font-size: 13.5px;
  color: #64748b;
  line-height: 1.6;
  margin: 0 0 24px;
}

.td-desc strong {
  color: #1e293b;
  font-weight: 600;
}

.td-actions {
  display: flex;
  gap: 8px;
}

.td-btn-ghost {
  flex: 1;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13.5px;
  font-weight: 500;
  color: #64748b;
  background: transparent;
  cursor: pointer;
  transition: all 0.15s;
}
.td-btn-ghost:hover { background: #f8fafc; color: #1e293b; }
.td-btn-ghost:disabled { opacity: 0.5; cursor: not-allowed; }

.td-btn-danger {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 10px;
  background: #dc2626;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}
.td-btn-danger:hover { background: #b91c1c; }
.td-btn-danger:disabled { opacity: 0.6; cursor: not-allowed; }

.td-spinner {
  width: 13px;
  height: 13px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: td-spin 0.7s linear infinite;
}
@keyframes td-spin { to { transform: rotate(360deg); } }
</style>